import { render, staticRenderFns } from "./odd-router-view.vue?vue&type=template&id=b8a73010"
import script from "./odd-router-view.vue?vue&type=script&lang=js"
export * from "./odd-router-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports